import { render, staticRenderFns } from "./basemap-item.vue?vue&type=template&id=12982318&"
import script from "./basemap-item.vue?vue&type=script&lang=js&"
export * from "./basemap-item.vue?vue&type=script&lang=js&"
import style0 from "./basemap-item.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VChip } from 'vuetify/lib/components/VChip';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VCard,VCheckbox,VChip,VImg})
